import React from 'react'
import { TypographyV2 as Typography } from '@which/seatbelt'

import { Link } from '../../../../shared/components/Link'

export const AffiliateDisclaimer: React.FC = () => (
  <Typography data-testid="affiliate-links-disclaimer" textStyle="sb-text-body-small-regular">
    Prices are ordered from lowest to highest, irrespective of retailer rating or stock, and exclude
    any potential delivery costs. We are not able to show every possible retailer and cheaper prices
    may be available. When you click on a retailer link, we may earn{' '}
    <Link
      href="https://www.which.co.uk/help/which-affiliate-activity-aPA408A93lxh"
      textStyle="sb-text-interface-body-x-small-regular"
    >
      affiliate commission
    </Link>
    , which helps fund our{' '}
    <Link
      href="https://www.which.co.uk/about-which/who-we-are-azQ8t7R93VDg#the-which-group"
      textStyle="sb-text-interface-body-x-small-regular"
    >
      not-for-profit mission
    </Link>
    . This tracks your activity using third party{' '}
    <Link
      href="https://www.which.co.uk/help/our-cookies-policy-your-cookies-preferences-aAuoo0H8Zif6"
      textStyle="sb-text-interface-body-x-small-regular"
    >
      cookies
    </Link>
    . By clicking a link you are consenting to this.
  </Typography>
)
